export default __webpack_public_path__ + "static/testimonials-dexko-global-b917d802cf4b5ab538c48903d5fc3fd4.png";